/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type BookedToChangeReasonEnum =
  (typeof BookedToChangeReasonEnum)[keyof typeof BookedToChangeReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookedToChangeReasonEnum = {
  CustomerRequest: 0,
  ChangedInRide: 1,
  CarNotReady: 2,
  NoFieldTesterAvailable: 3,
  PlanningCoordination: 4,
  CorrectionOfWrongTime: 5,
  Other: 6,
} as const;
